module.exports = __webpack_public_path__ + "img/truck-mixer.3513ef7.png";